import script from "./promotions-and-global-reach.vue?vue&type=script&setup=true&lang=js"
export * from "./promotions-and-global-reach.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__